import React, { useEffect, useState } from "react";
// import "../../../assets/UFC_DC_V3/scss/modules/custom.scss";
import "../../assets/UFC_DC_V3/scss/modules/anim.scss";
import "../../assets/UFC_DC_V3/scss/modules/checklist.scss";
import "../../assets/UFC_DC_V3/scss/modules/personaldetails.scss";
import "../../assets/UFC_DC_V3/scss/modules/questionnaire.scss";
import Footer from '../Includes/Layouts/UFC_DC_V4/Footer';
import GetVisitorsParams from "../../Utility/GetVisitorsParams";
import Questions from "../Includes/Layouts/UFC_DC_V4/Questions";

const CreditQuest_UFC_DC_V4 = () => {
    return (
        <>
            <div className='UFC_DC_V3'>
                <GetVisitorsParams />
                <Questions/>
                <Footer />
            </div>
        </>
    )
}

export default CreditQuest_UFC_DC_V4;